module.exports = __webpack_public_path__ + "img/grid.f716bd08.svg";